/**
 * Build with Customer Styles
 */

import { mergeStyleSets } from "@fluentui/react";
import { CSSProperties } from "react";

export const BUILD_WITH_CUSTOMER_STYLES = mergeStyleSets({
  root: {
    padding: "12px",
    background: "#FFFFFF"
  } as CSSProperties,
  header: {
    padding: "24px 12px 12px 12px",
    background: "#0078D4",
    color: "#FFFFFF"
  } as CSSProperties,
  headerTitle: {
    fontSize: "24px",
    fontWeight: "600",
    marginBottom: "4px"
  } as CSSProperties,
  headerSubtitle: {
    fontSize: "14px",
    fontWeight: "400",
    color: "#E8E8E8"
  } as CSSProperties,
  headerLogoBadge: {
    background: "linear-gradient(135deg, #0f3d6e, #2980b9)",
    color: "white",
    borderRadius: "14px",
    padding: "18px 22px",
    fontSize: "20px",
    lineHeight: 1,
    marginRight: "18px",
    boxShadow: "0 4px 12px rgba(15, 61, 110, 0.3)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "7px"
  } as CSSProperties,
  headerLeft: {
    display: "flex",
    alignItems: "center",
    gap: "14px"
  } as CSSProperties,
  headerBtnSecondary: {
    background: "linear-gradient(135deg, #95a5a6, #7f8c8d)",
    color: "#fff"
  } as CSSProperties,
  lensButtons: {
    display: "flex",
    gap: "12px",
    paddingBottom: "16px",
    alignItems: "center"
  } as CSSProperties,
  lensButton: {
    padding: "8px 16px",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.2s ease"
  } as CSSProperties,
  lensButtonActive: {
    background: "#0078D4",
    color: "#FFFFFF"
  } as CSSProperties,
  lensButtonInactive: {
    background: "#FFFFFF",
    color: "#0078D4",
    border: "1px solid #0078D4"
  } as CSSProperties,
  breadcrumbContainer: {
    padding: "10px 12px 14px 12px",
    borderBottom: "1px solid #E1DFDD",
    marginBottom: "12px",
    background: "#FAFBFC",
    borderRadius: "8px"
  } as CSSProperties,
  subTabsRow: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    flexWrap: "wrap",
    padding: "4px",
    background: "#F8F9FB",
    border: "1px solid #E1DFDD",
    borderRadius: "8px",
    width: "fit-content",
    marginBottom: "10px"
  } as CSSProperties,
  subTabButton: {
    border: "1px solid transparent",
    padding: "7px 14px",
    borderRadius: "6px",
    cursor: "pointer",
    fontSize: "13px",
    fontWeight: "600",
    lineHeight: "18px",
    transition: "all 0.2s ease"
  } as CSSProperties,
  subTabButtonActive: {
    background: "#0078D4",
    color: "#FFFFFF",
    boxShadow: "0 1px 3px rgba(0, 120, 212, 0.25)"
  } as CSSProperties,
  subTabButtonInactive: {
    background: "#FFFFFF",
    color: "#323130",
    border: "1px solid #E1DFDD"
  } as CSSProperties,
  subTabContextText: {
    fontSize: "18px",
    lineHeight: "28px",
    fontWeight: "600",
    color: "#201F1E",
    marginTop: "8px",
    marginBottom: "0"
  } as CSSProperties,
  statsContainer: {
    display: "flex",
    gap: "18px",
    padding: "8px 0 16px 0",
    flexWrap: "nowrap"
  } as CSSProperties,
  statCard: {
    flex: "1 1 0",
    minWidth: "0",
    padding: "0",
    background: "#F3F5F8",
    border: "1px solid #E6EBF2",
    borderRadius: "8px"
  } as CSSProperties,
  statCardRoot: {
    padding: "18px 16px",
    marginBottom: "0"
  } as CSSProperties,
  statLabel: {
    fontSize: "11px",
    letterSpacing: "0.8px",
    color: "#5B6E8B",
    fontWeight: "700",
    marginBottom: "8px",
    textTransform: "uppercase",
    lineHeight: "16px"
  } as CSSProperties,
  statValue: {
    fontSize: "34px",
    lineHeight: "40px",
    fontWeight: "700",
    color: "#1A2A45",
    marginBottom: "6px"
  } as CSSProperties,
  statChange: {
    fontSize: "13px",
    lineHeight: "20px",
    color: "#008F6B",
    fontWeight: "500"
  } as CSSProperties,
  statChangeNegative: {
    fontSize: "13px",
    lineHeight: "20px",
    color: "#DA3B01",
    fontWeight: "500"
  } as CSSProperties,
  statSubTextNeutral: {
    fontSize: "13px",
    lineHeight: "20px",
    color: "#1A2A45",
    fontWeight: "400"
  } as CSSProperties,
  statSubTextPositive: {
    fontSize: "13px",
    lineHeight: "20px",
    color: "#008F6B",
    fontWeight: "500"
  } as CSSProperties,
  statSubTextNegative: {
    fontSize: "13px",
    lineHeight: "20px",
    color: "#E53935",
    fontWeight: "500"
  } as CSSProperties,
  kanbanContainer: {
    display: "flex",
    gap: "16px",
    overflowX: "auto",
    padding: "12px 0",
    marginBottom: "24px"
  } as CSSProperties,
  kanbanColumn: {
    minWidth: "220px",
    flex: "0 0 220px",
    background: "#F0F0F0",
    borderRadius: "4px",
    padding: "8px"
  } as CSSProperties,
  kanbanColumnHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px",
    background: "#E8E8E8",
    borderRadius: "2px",
    marginBottom: "8px",
    fontWeight: "600",
    fontSize: "13px"
  } as CSSProperties,
  kanbanColumnCount: {
    display: "inline-block",
    background: "#0078D4",
    color: "white",
    padding: "2px 6px",
    borderRadius: "12px",
    fontSize: "11px",
    fontWeight: "600"
  } as CSSProperties,
  kanbanCard: {
    padding: "8px",
    marginBottom: "8px",
    background: "#FFFFFF",
    border: "1px solid #D0D0D0",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 1px 2px rgba(0,0,0,0.05)"
  } as CSSProperties,
  kanbanCardHover: {
    boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
  } as CSSProperties,
  kanbanCardName: {
    fontSize: "13px",
    fontWeight: "600",
    color: "#000000",
    marginBottom: "4px"
  } as CSSProperties,
  kanbanCardHealth: {
    fontSize: "11px",
    padding: "2px 6px",
    borderRadius: "2px",
    display: "inline-block"
  } as CSSProperties,
  tableContainer: {
    marginBottom: "24px"
  } as CSSProperties,
  funnelContainer: {
    display: "flex",
    gap: "24px",
    justifyContent: "center",
    padding: "24px",
    alignItems: "center",
    flexWrap: "wrap"
  } as CSSProperties,
  funnelSegment: {
    flex: "0 1 auto",
    textAlign: "center",
    padding: "12px"
  } as CSSProperties,
  pageRoot: {
    background: "#FFFFFF",
    minHeight: "100vh"
  } as CSSProperties,
  pageHeader: {
    background: "rgba(255, 255, 255, 0.97)",
    borderRadius: "14px",
    padding: "18px 28px",
    margin: "18px 20px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    boxShadow: "0 8px 32px rgba(0, 0, 0, 0.15)"
  } as CSSProperties,
  pageHeaderTitle: {
    fontSize: "26px",
    fontWeight: "700",
    color: "#0f3d6e",
    lineHeight: "1.2",
    letterSpacing: "-0.4px"
  } as CSSProperties,
  pageHeaderSubtitle: {
    fontSize: "13px",
    fontWeight: "400",
    color: "#7f8c8d",
    lineHeight: "18px",
    marginTop: "4px"
  } as CSSProperties,
  lensRow: {
    display: "flex",
    gap: "10px",
    padding: "14px 20px",
    alignItems: "center",
    background: "#FFFFFF",
    borderBottom: "1px solid #E1DFDD"
  } as CSSProperties,
  lensBtn: {
    padding: "8px 18px",
    border: "1.5px solid #0078D4",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "600",
    lineHeight: "20px",
    transition: "background 0.15s"
  } as CSSProperties,
  lensBtnActive: {
    background: "#0078D4",
    color: "#FFFFFF"
  } as CSSProperties,
  lensBtnInactive: {
    background: "#FFFFFF",
    color: "#0078D4"
  } as CSSProperties,

  // Main Tab Navigation (BwC Motion vs BwC Customers)
  mainTabNav: {
    background: "rgba(255, 255, 255, 0.97)",
    borderRadius: "12px",
    padding: "6px",
    display: "flex",
    gap: "4px",
    margin: "18px 20px",
    boxShadow: "0 4px 16px rgba(0, 0, 0, 0.1)",
    alignItems: "center"
  } as CSSProperties,
  mainTabBtn: {
    flex: 1,
    padding: "12px 16px",
    border: "none",
    borderRadius: "8px",
    background: "transparent",
    color: "#7f8c8d",
    fontWeight: 600,
    fontSize: "14px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.25s ease"
  } as CSSProperties,
  mainTabBtnActive: {
    background: "linear-gradient(135deg, #1a5fa8, #2980b9)",
    color: "#ffffff",
    boxShadow: "0 4px 12px rgba(41, 128, 185, 0.35)"
  } as CSSProperties,
  mainTabBtnInactive: {
    background: "transparent",
    color: "#7f8c8d"
  } as CSSProperties,
  mainTabDivider: {
    padding: "0 20px",
    color: "#95a5a6",
    fontSize: "13px",
    fontWeight: 500,
    whiteSpace: "nowrap"
  } as CSSProperties,

  subTabRow: {
    display: "flex",
    gap: "0",
    padding: "0 20px",
    background: "#FFFFFF",
    borderBottom: "1px solid #E1DFDD"
  } as CSSProperties,
  subTabBtn: {
    padding: "10px 18px",
    border: "none",
    borderBottom: "2px solid transparent",
    background: "transparent",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "400",
    color: "#605E5C",
    lineHeight: "20px",
    marginBottom: "-1px",
    transition: "all 0.15s"
  } as CSSProperties,
  subTabBtnActive: {
    color: "#0078D4",
    fontWeight: "600",
    borderBottom: "2px solid #0078D4"
  } as CSSProperties,
  pageBody: {
    padding: "20px"
  } as CSSProperties,
  contextLabel: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#1C355E",
    lineHeight: "32px",
    marginBottom: "20px",
    letterSpacing: "-0.2px",
    borderBottom: "1px solid #D1D1D1"
  } as CSSProperties,
  cardRowContainer: {
    display: "flex",
    gap: "20px",
    marginBottom: "20px"
  } as CSSProperties,
  cardSection: {
    flex: 1,
    background: "#FFFFFF",
    border: "1px solid #E1DFDD",
    borderRadius: "8px",
    padding: "16px",
    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.08)"
  } as CSSProperties,
  emptyStateContainer: {
    padding: "64px 16px",
    textAlign: "center" as const,
    color: "#605E5C",
    fontSize: "15px"
  } as CSSProperties
});

export const CUSTOM_CARD_STYLES = {
  root: {
    padding: "12px"
  },
  cardDetails: {
    padding: "12px"
  }
};
